import { render, staticRenderFns } from "./timeMachine.vue?vue&type=template&id=34fa5ca5&lang=pug&"
import script from "./timeMachine.vue?vue&type=script&lang=js&"
export * from "./timeMachine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports